<template>
  <div>
    <Toast />
    <Card>
      <template #title>
        {{ formTitle }}
      </template>
      <template #content>
        <div class="p-grid p-fluid p-mb-3">
          <div class="p-col-12 p-md-4">
            <label>Gudang</label>
            <AutoComplete
              placeholder="Warehouse"
              :dropdown="true"
              :multiple="false"
              v-model="selectedWarehouse"
              :suggestions="warehouseFiltered"
              @complete="searchWarehouse($event)"
              field="name"
              @input="isError.warehouse_id = false"
            >
              <template #item="slotProps">
                <div>{{ slotProps.item.code }} - {{ slotProps.item.name }}</div>
              </template>
            </AutoComplete>
            <small class="p-error" v-if="isError.warehouse_id">{{
              error_msg.warehouse_id
            }}</small>
          </div>
          <div class="p-col-12 p-md-4">
            <label>Nomor Bon</label>
            <InputText
              v-model="bon"
              :readonly="true"
              :disabled="true"
              placeholder="Auto Generate"
            />
          </div>
          <div class="p-col-12 p-md-4">
            <label>Tanggal Bon</label>
            <InputText
              type="date"
              :readonly="true"
              :disabled="true"
              v-model="today"
            />
          </div>
        </div>

        <!-- Horizontal scroll wrapper for DataTable -->
        <div style="overflow-x: auto; width: 100%">
          <DataTable
            :value="items_temp"
            editMode="row"
            scrollable
            scrollDirection="horizontal"
            responsiveLayout="scroll"
            style="min-width: 900px; width: 100%"
          >
            <Column
              field="selected_item"
              header="Kode"
              headerStyle="width: 10rem;"
              bodyStyle="width: 10rem;"
            >
              <template #body="slotProps">
                <AutoComplete
                  placeholder="Code"
                  :dropdown="true"
                  :multiple="false"
                  v-model="slotProps.data.selected_item"
                  :suggestions="autoFiltered[slotProps.index] || []"
                  @complete="getItems($event, slotProps.index)"
                  @input="chooseDropdownChanges(slotProps.index, $event)"
                  field="code"
                  class="autocomplete-zfix"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                  :ref="'autoInput' + slotProps.index"
                >
                  <template #item="slotProps2">
                    <div>{{ slotProps2.item.name }}</div>
                    <div style="font-style: italic; font-size: 12px">
                      {{ slotProps2.item.code }}
                    </div>
                  </template>
                </AutoComplete>
                <small
                  class="p-error"
                  v-if="
                    isError.items[slotProps.index] &&
                    isError.items[slotProps.index].id
                  "
                >
                  {{
                    error_msg.items[slotProps.index] &&
                    error_msg.items[slotProps.index].id
                  }}
                </small>
              </template>
            </Column>
            <Column
              field="name"
              header="Nama"
              headerStyle="width: 12rem;"
              bodyStyle="width: 12rem;"
            >
              <template #body="slotProps">
                <InputText
                  :disabled="true"
                  v-model="slotProps.data.name"
                  placeholder="Name"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                />
              </template>
            </Column>
            <Column
              field="stock"
              header="Stok"
              headerStyle="width: 5rem;"
              bodyStyle="width: 5rem;"
            >
              <template #body="slotProps">
                <InputText
                  :disabled="true"
                  v-model="slotProps.data.stock"
                  placeholder="Stok"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                />
              </template>
            </Column>
            <Column
              field="price"
              header="Harga (Rp)"
              headerStyle="width: 8rem;"
              bodyStyle="width: 8rem;"
            >
              <template #body="slotProps">
                <InputNumber
                  :disabled="true"
                  v-model="slotProps.data.price"
                  placeholder="Harga"
                  mode="currency"
                  currency="IDR"
                  locale="id-ID"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                />
              </template>
            </Column>
            <Column
              field="qty"
              header="Qty"
              headerStyle="width: 5rem;"
              bodyStyle="width: 5rem;"
            >
              <template #body="slotProps">
                <InputNumber
                  v-model="slotProps.data.qty"
                  placeholder=""
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                  :ref="'qtyInput' + slotProps.index"
                  @blur="qtyChanges($event, slotProps.index)"
                  @keydown.native="onQtyKeydown($event, slotProps.index)"
                />
                <small
                  class="p-error"
                  v-if="
                    isError.items[slotProps.index] &&
                    isError.items[slotProps.index].qty
                  "
                >
                  {{
                    error_msg.items[slotProps.index] &&
                    error_msg.items[slotProps.index].qty
                  }}
                </small>
              </template>
            </Column>
            <Column
              field="total"
              header="Total Harga"
              headerStyle="width: 10rem;"
              bodyStyle="width: 10rem;"
            >
              <template #body="slotProps">
                <InputNumber
                  :disabled="true"
                  v-model="slotProps.data.total"
                  placeholder="Total Harga"
                  mode="currency"
                  currency="IDR"
                  locale="id-ID"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                />
              </template>
            </Column>
            <Column
              field="description"
              header="Deskripsi"
              headerStyle="width: 10rem;"
              bodyStyle="width: 10rem;"
            >
              <template #body="slotProps">
                <InputText
                  :disabled="true"
                  v-model="slotProps.data.description"
                  placeholder="Deskripsi"
                  :style="{
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                  }"
                />
              </template>
            </Column>
            <Column headerStyle="width: 5rem;" bodyStyle="width: 5rem;">
              <template #body="slotProps">
                <Button
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="deleteRow(slotProps.index, slotProps.data)"
                />
              </template>
            </Column>
            <!-- Table Footer for Totals with 8 columns -->
            <template #footer>
              <tr>
                <td colspan="4" style="width: 337.5px"></td>
                <td style="width: 112.5px"><b>Total</b></td>
                <td style="width: 112.5px">
                  <b>{{ total_qty }}</b>
                </td>
                <td style="width: 112.5px">
                  <b>{{ total_price | currency }}</b>
                </td>
                <td style="width: 112.5px"></td>
              </tr>
            </template>
          </DataTable>
        </div>
        <!-- Add Row and Save Buttons -->
        <div class="p-mt-3 p-d-flex p-jc-end" style="gap: 1rem">
          <Button
            type="button"
            label="Simpan"
            class="p-button-primary"
            :disabled="loading.createButton"
            @click="saveForm"
            icon="pi pi-save"
          />
          <Button
            icon="pi pi-plus"
            label="Tambah Baris"
            class="p-button-success"
            @click="addNewRow"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
// If lodash.debounce is available, import it. Otherwise, a simple debounce is implemented below.
// import debounce from 'lodash.debounce'

export default {
  props: {
    formTitle: {
      type: String,
      required: true
    },
    defaultDescription: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isRequestPending: false,
      today: new Date().toISOString().split('T')[0],
      bon: null,
      autoFiltered: [],
      warehouseFiltered: [],
      selectedWarehouse: null,
      selectedWarehouses: null,
      items_checked: false,
      isError: {
        warehouse_id: false,
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false, description: false }]
      },
      error_msg: {
        warehouse_id: '',
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '', description: '' }]
      },
      items: [],
      total_price: 0,
      total_qty: 0,
      items_temp: [], // Will be initialized in created()
      inputData: {
        warehouse_id: 0,
        doc_number: '',
        doc_date: '',
        items: [], // Will be initialized in created()
        type: 'RETURN'
      },
      loading: {
        createButton: false
      },
      description_filtered: [], // Will be initialized in created()
      descriptions: '' // Will be initialized in created()
    }
  },
  created() {
    // Ensure at least five rows exist in items_temp
    if (!this.items_temp || this.items_temp.length < 3) {
      this.items_temp = Array.from({ length: 3 }, () => ({
        selected_item: '',
        name: '',
        stock: 0,
        qty: null,
        price: 0,
        total: 0,
        description: this.defaultDescription
      }))
    }
    if (!this.inputData.items || this.inputData.items.length < 3) {
      this.inputData.items = Array.from({ length: 3 }, () => ({
        id: 0,
        qty: 0,
        description: this.defaultDescription
      }))
    }
    if (!this.isError.items || this.isError.items.length < 3) {
      this.isError.items = Array.from({ length: 3 }, () => ({
        id: false,
        qty: false,
        description: false
      }))
    }
    if (!this.error_msg.items || this.error_msg.items.length < 3) {
      this.error_msg.items = Array.from({ length: 3 }, () => ({
        id: '',
        qty: '',
        description: ''
      }))
    }
    this.description_filtered = [{ descriptions: this.defaultDescription }]
    this.descriptions = this.defaultDescription
  },
  mounted() {
    this.getListWarehouse()
    this.getItems()
  },
  methods: {
    async getListWarehouse() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouses`
        )
        if (response.status === 200) {
          this.selectedWarehouses = response.data.data.warehouses
          this.selectedWarehouse = this.selectedWarehouses.find(
            item => item.name === 'Gudang Retur'
          )
        }
      } catch (error) {
        console.error('Error fetching warehouses:', error)
      }
    },
    searchWarehouse(event) {
      this.warehouseFiltered = this.selectedWarehouses.filter(item => {
        return item.name.toLowerCase().startsWith(event.query.toLowerCase())
      })
    },
    setDescription() {
      this.description_filtered = this.descriptions.filter(item => {
        return item.toLowerCase()
      })
    },
    getItems(event, index) {
      // Only call API if query is at least 3 characters
      if (!event || !event.query || event.query.length < 3) {
        this.$set(this.autoFiltered, index, [])
        return
      }
      if (!this.$_getItemsDebounced) {
        this.$_getItemsDebounced = this.debounce(this._getItems, 300)
      }
      this.$_getItemsDebounced(event, index)
    },
    _getItems(event, index) {
      let code
      if (event != null && event.query != null) {
        code = event.query
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/list/items?code=${code}&&show_empty_stock=false&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.bon = response.data.doc_number
            this.$set(this.autoFiltered, index, this.filterItems(event))
          }
        })
    },
    // Simple debounce implementation
    debounce(fn, delay) {
      let timeout
      return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },
    filterItems(event) {
      let query
      if (event != null && event.query != null) {
        query = event.query
      }
      return this.items.filter(item => {
        const lowerCaseQuery = query ? query.toLowerCase() : ''
        return (
          item.name.toLowerCase().indexOf(lowerCaseQuery) === 0 ||
          item.code.toLowerCase().indexOf(lowerCaseQuery) === 0
        )
      })
    },
    chooseDropdownChanges(index, selected_item) {
      if (!this.items_temp[index]) {
        return
      }
      for (const item of this.inputData.items) {
        if (item.id === selected_item.id) {
          this.showToast('error', 'Error Message', 'Barang sudah dipilih')
          this.items_temp[index].selected_item = ''
          this.items_temp[index].name = ''
          this.items_temp[index].stock = 0
          this.items_temp[index].price = 0
          this.inputData.items[index].id = 0
          this.inputData.items[index].qty = 0
          this.items_temp[index].qty = null
          return
        }
      }
      if (selected_item instanceof Object) {
        this.isError.items[index].id = false
        this.inputData.items[index].id = selected_item.id
        this.items_temp[index].price = parseFloat(selected_item.price)
        this.items_temp[index].name = selected_item.name
        this.items_temp[index].stock = selected_item.stock
        this.calculateLineTotal(index)
        // Move focus to qty input after selection
        this.$nextTick(() => {
          let ref = this.$refs['qtyInput' + index]
          if (ref) {
            ref.$el.querySelector('input').focus()
          }
        })
      }
    },
    qtyChanges(event, index) {
      this.isError.items[index].qty = false
      this.inputData.items[index].qty = parseInt(this.items_temp[index].qty)
      this.calculateLineTotal(index)
    },
    calculateLineTotal(index) {
      let qty = parseInt(this.items_temp[index].qty) || 0
      this.items_temp[index].total = qty * this.items_temp[index].price
      this.calculateTotal()
    },
    calculateTotal() {
      this.total_price = this.items_temp.reduce(function (sum, item) {
        return (sum += item.total)
      }, 0)
      this.total_qty = this.items_temp.reduce(function (sum, item) {
        const qty = parseInt(item.qty) || 0
        return (sum += qty)
      }, 0)
    },
    // --- Improved validation ---
    validateForm() {
      this.calculateTotal()
      let valid = true
      // Warehouse validation
      if (!(this.selectedWarehouse instanceof Object)) {
        this.loading.createButton = false
        this.isError.warehouse_id = true
        this.error_msg.warehouse_id = 'Pilih gudang terlebih dahulu.'
        this.showToast('error', 'Validasi Gagal', 'Gudang harus dipilih.')
        valid = false
      } else {
        this.isError.warehouse_id = false
        this.error_msg.warehouse_id = ''
      }
      // Items validation
      this.inputData.items.forEach((item, i) => {
        console.log('Validate Item:', item)
        // Item ID
        if (!item.id) {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'Pilih barang.'
          valid = false
        } else {
          this.isError.items[i].id = false
          this.error_msg.items[i].id = ''
        }
        // Quantity > 0
        if (!item.qty && item.qty <= 0) {
          console.log('Qty error, must be more than 0')
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'Harus > 0.'
          valid = false
        } else {
          this.isError.items[i].qty = false
          this.error_msg.items[i].qty = ''
        }
        // Quantity <= stock
        if (this.items_temp[i] && item.qty > this.items_temp[i].stock) {
          console.log('Qty error, must be less than stock')
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'Qty <= Stock'
          valid = false
        } else if (item.qty > 0) {
          // Only clear if qty is valid and not exceeding stock
          this.isError.items[i].qty = false
          this.error_msg.items[i].qty = ''
        }
        // Description
        if (!item.description || item.description === '') {
          this.isError.items[i].description = true
          this.error_msg.items[i].description = 'Deskripsi diperlukan.'
          valid = false
        } else {
          this.isError.items[i].description = false
          this.error_msg.items[i].description = ''
        }
      })
      console.log('Valid:', valid)
      return valid
    },
    deleteRow(k, _an_item) {
      this.items_temp.splice(k, 1)
      this.inputData.items.splice(k, 1)
      this.isError.items.splice(k, 1)
      this.error_msg.items.splice(k, 1)
      this.calculateTotal()
    },
    showToast(severity, summary, detail) {
      this.$toast.add({ severity, summary, detail, life: 3000 })
    },
    addNewRow() {
      this.items_temp.push({
        selected_item: '',
        name: '',
        stock: 0,
        qty: null,
        price: 0,
        total: 0,
        description: this.defaultDescription
      })
      this.inputData.items.push({
        id: 0,
        qty: 0,
        description: this.defaultDescription
      })
      this.isError.items.push({ id: false, qty: false, description: false })
      this.error_msg.items.push({ id: '', qty: '', description: '' })
    },
    saveForm() {
      if (!this.validateForm()) return
      // Sync form fields to inputData before submit
      this.inputData.warehouse_id = this.selectedWarehouse.id
      this.inputData.doc_number = this.bon
      this.inputData.doc_date = this.today
      console.log('Total Price:', this.total_price)
      console.log('Total Qty:', this.total_qty)

      if (this.total_price >= 0 && this.total_qty >= 0) {
        if (this.isRequestPending) {
          return // if request is live, prevent the function
        }
        this.isRequestPending = true // marking request is live
        this.loading.createButton = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds`,
            this.inputData
          )
          .then(response => {
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Submit items Success',
                life: 3000
              })
              this.resetForm()
              setTimeout(() => {
                this.getListWarehouse()
                this.getItems()
              }, 500)
            } else {
              let message = 'Terjadi kesalahan, silahkan coba lagi'
              if (response.data.message === 'error.post.item_negative_stock') {
                message =
                  'Terdapat barang dengan qty yang melebihi stok, silahkan cek kembali'
              }
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal Menyimpan',
                detail: message,
                life: 3000
              })
            }
          })
          .catch(() => {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal',
              detail: 'Terjadi kesalahan pada server',
              life: 3000
            })
          })
          .finally(() => {
            this.loading.createButton = false
            this.isRequestPending = false // Reset state, request is done
          })
      } else {
        console.log('Validation failed')
      }
    },
    resetForm() {
      this.total_price = 0
      this.total_qty = 0
      this.items_temp = Array.from({ length: 3 }, () => ({
        selected_item: '',
        name: '',
        stock: 0,
        qty: null,
        price: 0,
        total: 0,
        description: this.defaultDescription
      }))
      this.inputData.items = Array.from({ length: 3 }, () => ({
        id: 0,
        qty: 0,
        description: this.defaultDescription
      }))
      this.isError.items = Array.from({ length: 3 }, () => ({
        id: false,
        qty: false,
        description: false
      }))
      this.error_msg.items = Array.from({ length: 3 }, () => ({
        id: '',
        qty: '',
        description: ''
      }))
      this.selectedWarehouse = null
    },
    onQtyKeydown(event, index) {
      if ((event.key === 'Tab' || event.key === 'Enter') && !event.shiftKey) {
        const nextIndex = index + 1
        this.$nextTick(() => {
          const nextAuto = this.$refs['autoInput' + nextIndex]
          if (nextAuto && nextAuto.$el) {
            const input = nextAuto.$el.querySelector('input')
            if (input) {
              input.focus()
            }
          }
        })
      }
    }
  },
  beforeCreate() {
    this.$_getItemsDebounced = null
  }
}
</script>

<style scoped>
.autocomplete-zfix .p-autocomplete-panel {
  z-index: 1200 !important;
}

/* Ensure all input fields in DataTable fill the cell and do not overflow */
.p-datatable .p-inputtext,
.p-datatable .p-autocomplete,
.p-datatable .p-inputnumber,
.p-datatable .p-dropdown,
.p-datatable .p-button {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
/* Ensure InputNumber input fills the cell */
:deep(.p-datatable .p-inputnumber),
:deep(.p-datatable .p-inputnumber-input) {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
</style>
